import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminAppsComponent } from './admin-apps.component';

const routes: Routes = [
  {
    path: '',
    component: AdminAppsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminAppsRoutingModule {}
